// extracted by mini-css-extract-plugin
export default {"locationContainer":"hotelCardTitleBlock-module__locationContainer__myXRW","titleBlock":"hotelCardTitleBlock-module__titleBlock__v6eMV"};